import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { Chip, Icon, Tooltip } from '@mui/material';
import queryString from 'query-string';

import ledgerTypes from 'Lib/constants/accounting/ledgerTypes';
import useApi from 'Lib/hooks/useApi';

export default function Ledger(props) {
    const history = useHistory();
    const [data, setData] = useState([]);

    const fetchData = useApi(props.api.getLedgers);
    const filters = queryString.parse(history.location.search);

    useEffect(() => {
        fetchData({ ledgerIDs: Array.isArray(props.value) ? props.value : [props.value] }).then(response => {
            setData(response.data);
        });
    }, [filters[`${props.filter.name}`].length]);

    const chipData = {
        title: data.map(({ ledger }) => `${ledger.name} (${ledgerTypes.getName(ledger.ledgerTypeID)})`).join(', '),
        label: `${props.filter.label}${data.length > 1 ? `s (${data.length})` : ''}`
    };

    const { title, label } = chipData;

    return (
        <Tooltip title={title} arrow>
            <Chip label={label} onClick={props.onClick} onDelete={() => props.handleDelete(props.filter.name)} deleteIcon={<Icon>close</Icon>} />
        </Tooltip>
    );
}
